'use strict';

angular.module('directives.businessUnit', [])

.directive('businessUnit', [function () {
    return {
        scope: {
            bu: '=',
            tplVersion: '@'
        },
        template: '<span ng-include="getTemplateUrl()"></div>',
        controller: ['$scope', function ($scope) {

            $scope.getTemplateUrl = function () {
                var tplUrl = '/app/shared/components/directives/businessUnit.' +
                             $scope.tplVersion + '.tpl.html';

                return tplUrl;
            }

            $scope.initDepthColor = function (depth) {
                if (_.isUndefined(depth)) return;

                var depthColors = ['80', '115', '150', '185', '200', '200', '200', '200', '200'];

                $scope.depthColor = 'rgba(27, ' + depthColors[depth] + ', 150, 1)';
            }

            $scope.DepthColor = ['80', '115', '150', '185', '200', '200', '200', '200', '200'];
        }],
        link: function (scope, elem, attrs) {
            scope.initDepthColor(scope.bu.Depth);
        }
    }
}]);
